export default {
  recap: {
    language: 'Lengua',
    loadingRecap: 'Cargando resumen...',
    product: 'Producto',
    noPictureBrowser: 'No puede tomar fotografías en la versión del navegador de la aplicación.',
    differentImageReasonCode: 'Elija otro código de motivo de imagen.',
    validationError:
      'Ha dado una respuesta inválida a una pregunta. Por favor revise las preguntas a continuación.',
    page: {
      page: 'Página',
      back: 'Atrás',
      next: 'Siguiente Página',
      finish: 'Finalizar',
    },
    partialSaveError:
      'No se pudo guardar la encuesta incompleta. Si cambia de tarea y luego vuelve a esta, es posible que sus respuestas no se guarden.',
  },
  payPeriod: {
    title: '',
    cycle: '',
    delayNote: '',
    toBePaidHours: '',
    toBePaid: '',
    expenses: '',
    time: '',
    orderItems: '',
    edits: '',
    lastUpdated: '',
    accepted: '',
    declined: '',
    fixBy: '',
    incomplete: '',
    processing: '',
  },
  timeline: {
    welcome: '',
    pleaseSync: '',
    initializing: '',
    expenses: 'Gastos',
    totalTime: 'Tiempo Total',
    current: 'Presente',
    miles: 'Millas',
    km: '',
  },
  timecard: {
    denied: '',
    approved: '',
    processing: '',
    processingOpen: '',
    syncing: '',
    declined: '',
    elapsed: '',
    incomplete: '',
    editing: '',
    doneFixing: '',
    openTimecard: '',
  },
  activities: {
    storeTask: 'Tarea de una tienda',
    travel: 'Viaje',
    store: 'Visita a la tienda',
    communication: 'Comunicación',
    material: 'Coordinación de materiales',
    coupon: 'Devoluciones de cupones',
    break: 'Romper',
    training: 'Capacitación',
    team: '',
    other: 'Varios/Otros',
  },
  sideNav: {
    messages: 'Mensajes',
    expenses: 'Gastos',
    activities: 'Actividades',
    profile: 'Perfil',
    settings: 'Ajustes',
    support: 'Apoyo',
    signOut: 'Desconectar',
    currentPayPeriod: '',
  },
  settings: {
    profileOptions: '',
  },
  form: {
    maintenance: '',
    maintenanceMessage: '',
    job: '',
    wave: '',
    downloadPDFs: '',
    deletePDFs: '',
    deleteFilter: '',
    updateFilter: '',
    logoutRmActivities: '',
    logoutTimecardNotSub: '',
    logoutWipeActivities: '',
    logoutDestructive: '',
    warning: '',
    logout: '',
    agree: '',
    disagree: '',
    updateStatus: '',
    bulkUpdateRai: '',
    bulkUpdateRaiNote: '',
    bulkUpdateRaiFilter: '',
    bulkUpdateRaiNotApplicable:
      'El código RAI debe ser aplicable a todas las tareas seleccionadas.',
    wipeData: '',
    promptStoreVisit: '',
    promptDeleteActivityHeader: '',
    promptDeleteActivity: '',
    endCurrentMessage: '',
    newMessage: 'Nuevo mensaje',
    to: 'A',
    subject: 'Tema',
    message: 'Mensaje',
    sendMessage: 'Enviar mensaje',
    adjust: 'Ajustar',
    add: 'Agregar',
    description: 'Descripción',
    amount: 'Monto',
    date: 'Fecha',
    total: 'Total',
    sendExpenseReport: 'Enviar informe de gastos',
    addToOrder: 'Agregar a la orden',
    quantity: 'Cantidad',
    newQuantity: 'Nueva cantidad',
    reason: 'Razón',
    comment: 'Comentario',
    startStore: 'Iniciar visita a tienda',
    resumeStore: 'Resumen visita a tienda',
    endStore: 'Finalizar visita a tienda',
    endStoreActiveTask: '',
    activityType: 'Tipo de actividad',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    duration: 'Duración',
    startOdo: 'Odómetro de inicio',
    endOdo: 'Odómetro final',
    location: 'Localidad',
    distance: 'Distancia',
    destination: 'Destino',
    travelingMessage: 'Ahora estás viajando.',
    close: 'Cerca',
    save: 'Guardar',
    start: 'Inicio',
    continue: 'Continuar',
    cancel: 'Cancelar',
    departingFrom: 'Partiendo de',
    departingStore: 'Tienda de salida',
    destinationStore: 'Tienda de destino',
    startTravel: 'Iniciar viaje',
    stopTravel: 'Dejar de viajar',
    saveTravel: 'Guardar viaje',
    addActivity: 'Añadir actividad',
    saveNewActivity: 'Guardar nueva actividad',
    stopSave: 'Detener y guardar',
    delete: 'Borrar',
    type: 'El Tipo',
    requiredGeneric: 'Se requiere campo',
    notBeforeNow: '',
    startOverlapEnd: 'La hora de inicio no puede coincidir con la hora de finalización',
    endOverlapStart: 'La hora de finalización no puede coincidir con la hora de inicio',
    betweenActivities: 'No puede estar entre actividades existentes',
    overlapActivities: 'No se pueden superponer actividades existentes',
    odometerSmaller: 'La lectura debe ser más pequeña que el odómetro final',
    odometerLarger: 'La lectura debe ser mayor que el odómetro de inicio',
    endOfDay: 'Fin del día',
    endOfDayInfo: 'Estás a punto de terminar tu día si continúas.',
    travelOverride: '¿Aplicar la excepción de 30/30 millas? (Requiere aprobación AM)',
    travelOverrideCan: '¿Aplicar la excepción de 20/20 millas? (Requiere aprobación AM)',
    payrollCertLang: 'Idioma de Certificación de Nómina',
    childrenSum: 'Total time of tasks cannot be greater than store visit',
    endDay: 'Día de finalización',
    recapPreview: 'Resumen de vista previa',
    update: 'Actualizar',
    updateLastTask: '',
    options: {
      core: '',
      merchandising: '',
      transfer: '',
      atStore: '',
      unscheduledTasks: '',
      minimumHourRequirement: '',
      cartFraming: '',
      home: 'Hogar',
      warehouse: 'Depósito',
      store: 'Tienda',
      other: 'Otro',
      break: 'Pausa',
      paidBreak: 'Descanso pagado',
      virtualOnline: 'Virtual y en línea',
      virtualTrainer: 'Actividades de Entrenador Virtual',
      retailMerchCoach: 'Entrenador de comercialización minorista',
      operationSupport: 'Soporte de operaciones',
      recruitingDuties: 'Deberes de reclutamiento',
      instore: 'INSTORE',
      cart: 'CART',
      merch: 'MERCH',
    },
    messages: {
      message: '',
      reply: '',
      subject: '',
      departDestNotSame: 'Salida/Destino no puede ser el mismo',
      storesNotSame: 'Las tiendas de salida/destino no pueden ser las mismas',
      storesNotDefined: 'La tienda debe ser elegida',
      locationNotNull: 'Se debe seleccionar una ubicación',
      noResults: 'No hay resultados',
      fieldNotNull: 'La entrada no puede estar vacía',
      aboveZero: 'La entrada debe estar por encima de cero',
      notNegative: 'La entrada no debe ser negativa',
      noDecimal: 'La entrada debe ser un número entero',
    },
    orderReasons: {
      neverReceivedOriginal: 'Nunca recibido Original',
      receivedPartialShipment: 'Envío parcial recibido',
      receivedIncorrectMaterials: 'Recibió materiales incorrectos',
      materialsReceivedDamaged: 'Materiales recibidos dañados',
      others: 'Otro',
      lost: 'Perdió',
      damaged: 'Dañado',
      found: 'Fundar',
      transfer: 'Transferencia de representante a representante',
      cycleCount: 'Contador de Cíclos',
      recoveredAtStore: 'Recuperado en la tienda',
    },
  },
  language: 'Lengua',
  menu: {
    home: 'Casa',
    tasks: 'Tareas',
    stores: 'Tiendas',
    timeTracking: 'Seguimiento del Tiempo',
    inventory: 'Inventario',
    preferences: 'Preferencias',
    messaging: 'Mensajería',
    timeline: 'Cronología de la actividad',
    lastSynced: '',
  },
  login: {
    welcome: 'Bienvenido a FHS',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    login: 'Acceso',
    errorInvalid: 'Usuario o contraseña invalido',
    errorCommunication: 'No se puede iniciar sesión, inténtelo de nuevo más tarde',
    expired: '',
    connection: '',
    loggingIn: '',
  },
  data: {
    allData: '',
    item: 'elemento | elementos',
    noData: 'No hay datos para mostrar',
    noGroupData: 'No hay datos en este grupo para mostrar',
    filtering: {
      filter: 'Filtrar',
      addFilter: '',
      applyFilter: '',
      groupBy: 'Agrupar por',
      sortBy: 'Ordenar por',
      search: 'Buscar',
      addCondition: 'Añadir condición',
      field: 'Dominio',
      operator: 'Operador',
      date: 'Fecha',
      value: 'Valor',
      operators: {
        comparison: {
          equals: 'es igual',
          notEqual: 'no es igual',
          greaterThan: 'mas grande que',
          lessThan: 'menos que',
          is: 'es',
          isNot: 'no es',
          isEmpty: 'está vacío',
          onDate: 'en la fecha',
          onOrBefore: 'en o antes la fecha',
          onOrAfter: 'en o depués la fecha',
          beforeDate: 'antes de la fecha',
          afterDate: 'después de la fecha',
          isTrue: 'es verdad',
          isFalse: 'es falso',
          isAnyOf: 'is any of',
          isNotAnyOf: 'is not any of',
        },
        date: {
          exactDate: 'fecha exacta',
          today: 'hoy',
          tomorrow: 'mañana',
          yesterday: 'ayer',
          oneWeekPast: 'hace una semana',
          oneWeekFuture: 'una semana a partir de ahora',
          oneMonthPast: 'hace un mes',
          oneMonthFuture: 'un mes a partir de ahora',
        },
      },
    },
  },
  media: {
    takePhoto: 'Tomar Foto',
    clearPhotos: 'Borrar Fotos',
    savingPhoto: 'Guardando foto...',
    abortUpload: 'Cancelar Carga',
    error: 'Algo salió mal al capturar la foto, inténtalo de nuevo.',
  },
  storeItems: {
    suggestEdit: '',
    details: 'Detalles',
    survey: 'Encuesta',
    carts: 'Carros',
    pedestals: 'Pedestales',
    small_carts_1sd: 'Mueble pequeño formato - 1 cara',
    small_carts_std: 'Mueble pequeño formato - 2 caras',
    small_carts_thin: 'Unidad delgada de factor de forma pequeño',
    large_carts_1sd: 'Mueble gran formato – 1 cara',
    large_carts_std: 'Mueble gran formato - 2 caras',
    liberty_pedestals: 'Pedestales Liberty',
    evolve_pedestals: 'Evolucionar pedestales',
    other_pedestals: 'Otros pedestales',
    e10_pedestals: 'E10',
    p20_pedestals: 'P20',
    noAdPanel_pedestals: 'Liberty/Evolve No Ad Panel',
    manned_checkout_number: 'Pagos atendidos',
    self_checkout_number: 'Autopagos',
    no_of_coupon_zones: 'CZB',
    notes: 'Notas',
    store_items: 'Elementos',
    store_manager: 'Gerente',
    class_of_trade: 'Clase de Comercio',
    report: 'Reportar un hecho',
    tasks: 'Tareas',
    productLines: 'Líneas de productos',
    picklist: 'lista de selección',
    recommendations: 'Recomendaciones',
    visiting: 'Visitando',
    contact_name: 'Manager',
    store_number: 'Número de tiend',
    chain_name: 'Nombre de la cadena',
    chain_short_name: 'Nombre corto de la cadena',
    end_survey: 'Terminar encuesta',
    update_survey: 'Actualizar encuesta',
  },
  taskProfile: {
    noTask: '',
    product_line: 'Línea de producto',
    artwork: 'Obra de arte',
    order_sale_id: 'ID de venta de pedido',
    space_id: 'ID de espacio',
    instructions: 'Instrucciones',
    previous_rai: 'RAI anterior',
    previous_inventory_item: 'Artículo de inventario anterior',
    previous_placement: 'Colocación anterior',
    ad_qty_type: 'Cantidad y tipo de anuncios',
    previous_ad_qty: 'Cantidad de anuncio anterior',
    placement_section: 'Sección de colocación',
    task: 'Tarea',
    task_type: 'Tipo de tarea',
    errorSavingRecap: 'Algo salió mal al intentar finalizar la tarea. Inténtalo de nuevo.',
    supplies_sent_to: 'Suministros enviados a',
    kit: 'Equipo',
    art_description: 'Descripción del arte',
    job_description: 'Descripción del trabajo',
    job_id: 'Identificación del trabajo',
    wave: 'Ola',
    est_task_duration: 'Duración estimada de la tarea',
    attachment: 'Archivo adjunto',
    running: 'Activo',
    paused: 'En pausa',
    open: 'Abierto',
    submitted: 'Presentada',
    completed: 'Terminado',
    checkInToStart: 'Regístrese en la tienda para comenzar esta tarea',
    resumeTask: 'reanudar la tarea',
    startTask: 'Iniciar tarea',
    endTask: 'Tarea final',
    pauseTask: 'Pausar tarea',
    cancelTask: 'Cancelar tarea',
    showRecap: 'Mostrar resumen',
    includeRecap: 'Incluir resumen',
    desc_art_id: '',
    initial_image_rai: '',
    inventory_item: '',
    limited_quantity_buy: '',
    maintain_image_rai: '',
    order_sales_id: '',
    previous_rai_code: '',
    previous_ad_quantity: '',
    quantity_installed: '',
    remove_image_rai: '',
    special_instructions: '',
    task_status: '',
    value: '',
    test_indicator: '',
    prev_item_installed: '',
    artwork_id: '',
    previous_placement_id: '',
    previous_execution_timestamp_tz: '',
  },
  tables: {
    tasks: 'Tareas',
    merchPlanner: 'Planificador de merchandising',
    stores: 'Tiendas',
    workView: 'Vista de trabajo',
    balance: 'Balance',
    allItems: 'Todos los artículos',
    orders: 'Pedidos',
  },
  messaging: {
    offline:
      'Está desconectado, los mensajes se enviarán/recibirán cuando el dispositivo esté conectado.',
    noMessagesInbox: 'Tu bandeja de entrada está vacía.',
    noMessagesOutbox: 'Su bandeja de salida está vacía.',
    sentMessagesRemoved: 'Los mensajes enviados se eliminan automáticamente después de 30 días',
    inbox: 'Bandeja de entrada',
    outbox: 'Bandeja de salida',
    sent: 'Enviado',
  },
}
